import { connect } from 'react-redux';
import { checkPassword, clearCheckPassword, fetchBaseUsers, selectCurrentUser, resetCurrentUser, fetchMobileUsers, grabMobileUserID, fetchUsername, clearUsernameData } from '../../actions/settings_actions';

import UserManagement from '../../components/Settings/userManagement';

function mapStateToProps(state) {
    return {
        users: state.settings.all,
        isLoading: state.settings.isLoading,
        error: state.settings.error,
        userType: state.auth.userType,
        userPermissions: state.auth.userPermissions,
        mobileUsers: state.settings.mobileUsers,
        mobileUsersTotalPages: state.settings.mobileUsersTotalPages,
        mobileUsersTotalCount: state.settings.mobileUsersTotalCount,
        mobileUsersIsLoading: state.settings.mobileUsersIsLoading,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
        mobileUserId: state.settings.mobileUserId,
        usernameIsLoading: state.settings.usernameIsLoading,
        username: state.settings.username,
        usernameError: state.settings.usernameError,
        selectedCompany: state.header.selectedCompany,
    };
}

export default connect(mapStateToProps, {
  checkPassword,
  clearCheckPassword,
  fetchBaseUsers,
  selectCurrentUser,
  resetCurrentUser,
  fetchMobileUsers,
  grabMobileUserID,
  fetchUsername,
  clearUsernameData,
})(UserManagement);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/userManagement.jsx